import api from './api'
import { assoc, path, pipe, prop } from 'ramda'

const message = ($http) => {
  'ngInject'

  /**
   * data.userIds - array of external user IDs.
   * data.messages - array of messages.
   * data.fromCompany - if it is from a company or us.
   */
  const messageGroup = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/text/group`,
      data})
      .then(path(['data', 'message']))
  }

  const messageGroupFromCompany = pipe(
    assoc('fromCompany', true),
    messageGroup
  )

    /**
   * data.userIds - array of external user IDs.
   * data.messages - array of messages.
   */

  const intercomGroup = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/intercom/group`,
      data})
    .then(prop('data'))
  }

  const getIntercomConversations = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/intercom/getIntercomMessages`,
      data
    })
      .then(prop('data'))
  }

  const getAdminConversations = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/intercom/getAdminConversations`,
      data
    })
      .then(prop('data'))
  }

  const createBranchSource = (data) => {
    return $http({
      method: 'POST',
      url: `${api.getBase()}/source/create`,
      data
    })
    .then(prop('data'))
  }

  return {
    createBranchSource,
    messageGroup,
    intercomGroup,
    messageGroupFromCompany,
    getAdminConversations,
    getIntercomConversations
  }
}

message.$inject = ['$http']

export default message
